import { httpAuth2 } from "@/api/auth";
import { httpPublic2 } from "@/api/public";

export const obfuscationRequests = {
  obfuscationCreate: ({ context, data } = {}) => {
    return httpAuth2.post("/v1/obfuscation/create", { context, json: data }).json();
  },
  obfuscationGetWithUsername: ({ context, data } = {}) => {
    return httpPublic2.post("/v1/obfuscation/get_with_username", { context, json: data }).json();
  },
};
